/* HRD contextual Shopify contact form and preaddressed email alternative. */
(() => {
  const init = () => {
    document.querySelectorAll('[data-hrd-inquiry]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('.hrd-inquiry-form');
      if (!form) return;
      const params = new URLSearchParams(location.search);
      const limit = (s, max=150) => (s || '').replace(/[\r\n]/g, ' ').trim().slice(0,max);
      const topic = form.querySelector('[data-inquiry-topic]');
      const subject = form.querySelector('[data-inquiry-subject]');
      const mail = root.querySelector('[data-inquiry-mailto]');
      const gen = form.querySelector('#HrdGeneration');
      const body = form.querySelector('#HrdDetails');
      const type = limit(params.get('topic'),50).toLowerCase();
      const service = limit(params.get('service') || params.get('install_service'));
      const item = limit(params.get('item') || params.get('product') || params.get('install_product') || params.get('build_goal'));
      const variant = limit(params.get('install_variant'));
      const generation = limit(params.get('generation') || params.get('install_generation'),50);
      const map = {'installation':'Installation Request','custom-fabrication':'Custom Fabrication','fabrication':'Custom Fabrication','custom-build':'Custom Raptor Build','build':'Custom Raptor Build','suspension':'Suspension / Steering','steering':'Suspension / Steering','dealer':'Dealer Parts','technical':'Product Fitment','fitment':'Product Fitment','general':'General Question'};
      if (map[type]) topic.value = map[type];
      else if (root.dataset.page !== 'request-installation') topic.value = 'General Question';
      if (generation) for (const option of gen.options) if (generation.startsWith(option.value) && option.value) { gen.value = option.value; break; }
      const interest = form.querySelector('[data-inquiry-product]');
      if (interest) interest.value = [item,variant].filter(Boolean).join(' / ');
      const ref = form.querySelector('[data-inquiry-referrer]');
      if (ref) ref.value = [limit(params.get('install_url'),350) || document.referrer,service].filter(Boolean).join(' / ').slice(0,500);
      const shopEmail = root.dataset.email || 'sales@hannarace.com';
      const refresh = () => {
        const qualifier = item || service;
        const label = ('HRD ' + topic.value + (qualifier ? ' — ' + qualifier : '')).slice(0,185);
        subject.value = label;
        const lines = [
          'Name: ' + (form.querySelector('#HrdName')?.value || ''),
          'Email: ' + (form.querySelector('#HrdEmail')?.value || ''),
          'Phone: ' + (form.querySelector('#HrdPhone')?.value || ''),
          'Generation: ' + gen.value,
          'Requested service: ' + (service || topic.value),
          'Product / item: ' + item,
          'Variant: ' + variant,
          'Source page: ' + window.location.href.split('#')[0],
          'Original link / service: ' + (limit(params.get('install_url'),350) || document.referrer || 'Direct visit'),
          '',
          body.value || 'Tell HRD about your project:'
        ];
        mail.href = 'mailto:' + shopEmail + '?subject=' + encodeURIComponent(label) + '&body=' + encodeURIComponent(lines.join('\n'));
      };
      topic.addEventListener('change',refresh);
      form.querySelectorAll('input:not([readonly]),textarea,select').forEach(field => {
        field.addEventListener('input',refresh);
        field.addEventListener('change',refresh);
      });
      form.addEventListener('submit', () => {
        const prefix = 'Subject: ' + subject.value + '\n\n';
        if (!body.value.startsWith('Subject: ')) body.value = prefix + body.value;
      });
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();